import { Button, DataGrid } from 'devextreme-react'
import React, { useMemo, useRef, useState } from 'react'
import { getPropsDataGrid } from '../../../../utils/default-props'
import { Column, Editing, Item, Toolbar } from 'devextreme-react/cjs/data-grid'
import { getDataGridCustomToolbarCaption } from '../../../../components/default-components/data-grid-custom-toolbar'
import { useDataSource } from '../../../../contexts/dataSource'
import { EmployeDocumentCardPopup } from './employee-document-card'
import useAxiosPrivate, { axiosHrPrivate } from '../../../../api/useAxios'
import { EmployeeDocumentCardMultiAdd } from './employee-document-card-multiadd.tsx'


function EmployeeDocumentList({ employeeId }) {

    const [popup, setPopup] = useState(false)
    const [multiAddPopup, setMultiAddPopup] = useState(false)
    const { dataSourceHR } = useDataSource()
    const [selectedId, setSelecttedId] = useState(null)
    const dataGridRef = useRef(undefined)


    const dataSource = useMemo(() => dataSourceHR({
        loadUrl: `/api/EmployeeDocument/Employee/${employeeId}`,
        deleteUrl: `/api/EmployeeDocument/FormData`
    }), [employeeId, dataSourceHR])

    const onCardPopupHiding = () => {
        setPopup(!popup)
    }

    const onMultiAddPopupHiding = () => {
        setMultiAddPopup(false)
        onAfterMultiAdd()
    }
    const refreshDataGrid = () => {
        dataGridRef?.current?.instance?.refresh()
            .then(function () {
                // ...
            })
            .catch(function (error) {
                // ...
            });
    }

    const onAfterAdd = () => {
        //console.log("reacord added");
        refreshDataGrid()
        //başka işlemler...

    }
    const onAfterMultiAdd = () => {
        //console.log("reacord added");
        refreshDataGrid()
        //başka işlemler...

    }
    const handleFocusedRowChange = (e) => {
        setSelecttedId(e.component.option('focusedRowKey'));
        console.log("e.component.option('focusedRowKey')", e.component.option('focusedRowKey'))
    }

    return (
        <React.Fragment>
            <DataGrid
                dataSource={employeeId ? dataSource : undefined}
                {...getPropsDataGrid}
                ref={dataGridRef}
                onFocusedRowChanged={handleFocusedRowChange}
            >
                <Editing
                    useIcons={true}
                    mode="row"
                    allowDeleting={true}
                //allowUpdating={true}

                />
                <Toolbar>
                    {getDataGridCustomToolbarCaption("Dökümanlar")}
                    {/* <Item name="addRowButton" location="after" /> */}
                    <Item location='after'>
                        <Button icon='add' onClick={onCardPopupHiding} />
                    </Item>
                    <Item location='after'>
                        <Button icon='importselected' onClick={() => setMultiAddPopup(true)} />
                    </Item>
                </Toolbar>
                <Column dataField="lastUploadDate" caption="Tarih" dataType="date" />
                <Column dataField="employeeDocumentInfoName" caption="Döküman Tipi" />
                <Column dataField="description" caption="Açıklama" />
                <Column dataField="approvalStatus" caption="Onay" />
                <Column caption="Belge" cellRender={DocumentCellRender} />
            </DataGrid>
            {popup &&
                <EmployeDocumentCardPopup
                    id={selectedId}
                    employeeId={employeeId}
                    visible={popup}
                    setVisible={setPopup}
                    onHiding={onCardPopupHiding}
                    onAfterAdd={onAfterAdd}
                />
            }
            {multiAddPopup &&
                <EmployeeDocumentCardMultiAdd
                    visible={multiAddPopup}
                    onHiding={onMultiAddPopupHiding}
                    onAfterAdd={onAfterMultiAdd}
                    employeeId={employeeId}

                />
            }

        </React.Fragment>
    )
}

export const DocumentCellRender = (cellData) => {
    const axiosPrivate = useAxiosPrivate(axiosHrPrivate)

    const openFileInNewTab = async () => {
        try {
            const response = await axiosPrivate.get(`api/EmployeeDocument/Document/${cellData?.data?.id}`, {
                responseType: 'blob'
            });

            const fileName = cellData?.data?.fileName || "bilinmeyen_dosya";

            let mimeType = 'application/octet-stream'; // Varsayılan

            if (fileName.endsWith('.pdf')) {
                mimeType = 'application/pdf';
            } else if (fileName.endsWith('.png')) {
                mimeType = 'image/png';
            } else if (fileName.endsWith('.jpg') || fileName.endsWith('.jpeg')) {
                mimeType = 'image/jpeg';
            } else if (fileName.endsWith('.txt')) {
                mimeType = 'text/plain';
            }

            if (mimeType == 'application/octet-stream') {
                const fileUrl = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = fileUrl;
                link.setAttribute('download', cellData?.data?.fileName ?? "bilinmeyen_dosya"); // Dosya adını ayarlayın
                document.body.appendChild(link);
                link.click();

                // Linki ve URL'yi temizleyin
                link.parentNode.removeChild(link);
                window.URL.revokeObjectURL(fileUrl);
            }
            else {
                const fileBlob = new Blob([response.data], { type: mimeType });
                const fileUrl = window.URL.createObjectURL(fileBlob,);
                window.open(fileUrl, '_blank');
                window.URL.revokeObjectURL(fileUrl);
            }


        } catch (error) {
            console.error('Error opening the file', error);
        }

        // Hangi Veriler Olabilir?
        // application/pdf: PDF dosyası.
        // image/jpeg: JPEG formatında bir resim dosyası.
        // image/png: PNG formatında bir resim dosyası.
        // application/json: JSON formatında bir veri.
        // text/plain: Düz metin dosyası.
        // application/zip: ZIP arşiv dosyası.
        // application/octet-stream: Genel bir ikili veri türü. Dosyanın türü tam olarak bilinmediğinde kullanılır.        
    };

    return (
        <div>
            <Button
                icon='doc'
                disabled={!cellData.data.fileSize}
                onClick={openFileInNewTab}
            />
        </div>
    )
}



export default EmployeeDocumentList